export function login (credentials) {
  return new Promise((res, rej) => {
    window.axios.post('/auth/login', credentials)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        rej(error);
      });
  });
}

export default function getLocalUser () {
  const userStr = localStorage.getItem('user');
  if (!userStr) {
    return null;
  }

  return JSON.parse(userStr);
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js